import AsyncSelect from '@/components/form-elements/AsyncSelect/AsyncSelect.vue';
import Datepicker from '@/components/form-elements/Datepicker/Datepicker.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import type { FormConfig } from '@/utils/form';
import { DsCheckbox } from '@demvsystems/design-components';
import { propertyBeitragsReduzierungSection } from '@/features/Sparten/shared/formConfigs/property/input/beitragsReduzierungSection';

export const clientSection: FormConfig = {
  formName: 'UnfClient',
  fieldConfigs: [
    {
      component: AsyncSelect,
      path: 'tarifgruppe',
      label: 'Tarifgruppe',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.TARIFGRUPPE,
      },
    },
  ],
};

export const absicherungsSection: FormConfig = {
  formName: 'UnfAbsicherung',
  fieldConfigs: [
    {
      component: Datepicker,
      path: 'versicherungsbeginn',
      label: 'Versicherungsbeginn',
    },
    {
      component: AsyncSelect,
      path: 'laufzeit',
      label: 'Laufzeit',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.LAUFZEIT,
      },
    },
    {
      component: AsyncSelect,
      path: 'zahlweise',
      label: 'Zahlweise',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.PAYMENT_PERIOD,
      },
    },
  ],
};

export const beitragsReduzierungSection: FormConfig = {
  formName: 'UnfBeitragsreduzierung',
  fieldConfigs: [
    ...propertyBeitragsReduzierungSection.fieldConfigs,
    {
      component: DsCheckbox,
      path: 'gesundheitsfragenVerzicht',
      label: 'Nur Tarife ohne Gesundheitsfragen',
      inlineGroup: true,
      formGroupClass: ['justify-end', 'mb-2'],
    },
  ],
};
